import React from "react";
import { Dropdown } from "react-bootstrap";
import "./mspSubscriptionAccounts.scss";
import StatusIndicator from "./StatusIndicator";
import { SUBSCRIPTION_STATUSES } from "../../../constants/subscription.constants";
import SuccessSignIcon from "../../icons/success-sign.icon";
import TrialCard from "./trial-card.component";
import Loader from "../../Common/loader";

const MspAccountSubscriptions = ({ pageLoading, subscriptionData}) => {
  if (pageLoading) {
    return (
      <div className="d-flex align-items-center justify-content-center h-100 mt-5">
        <Loader />
      </div>
    )
  }

  return (
    <div className="subscription-container msp-account-subscription mt-5">
      <div className="f-16 f-600 my-3">Subscription and Billing</div>

      {subscriptionData?.ActiveSubscriptionDetails && (
        <>
          <div className="d-flex align-items-center justify-content-between mt-3 mb-2">
            <div>
              {subscriptionData?.ActiveSubscriptionDetails?.SectionTitle}
            </div>
          </div>

          <div className="sub-table bg-grey border-parent radius-8 overflow-x-auto hide-scrollbar no-wrap d-grid">
            {subscriptionData?.ActiveSubscriptionDetails?.Subscriptions?.map((item) => (
              <div className="border-item p-3">
                <div className="f-500 f-black d-flex align-items-center">
                  {item?.Title}
                </div>
                <div>
                  <div>
                    {item?.Value}
                  </div>
                  {item?.Description && (
                    <div className="f-darkgrey">
                      {item?.Description}
                    </div>
                  )}
                </div>
                <div className="d-flex justify-content-end align-items-center">
                  {item?.Price}
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {subscriptionData?.TrailDetails && (
        <>
          <div className="d-flex align-items-center justify-content-between mt-3 mb-2">
            <div>
              {subscriptionData?.TrailDetails?.SectionTitle}
            </div>
          </div>
          <div className="bg-grey border-parent radius-8 overflow-x-auto hide-scrollbar no-wrap d-grid">
            {subscriptionData?.TrailDetails?.Trials?.map((item) => (
              <TrialCard 
                trialData={{
                  title: item?.TrialType,
                  dateRange: item?.ValidUpto,
                  progress: item?.Days,
                  status: item?.Status,
                }}
              />
            ))}
          </div>
        </>
      )}

      {subscriptionData?.Usage && (
        <>
          <div className="f-14 f-500 mb-3 mt-4">Usage</div>
          <div className="usage-container bg-grey">
            <div className="p-3 flex-1 item">
              <div className="f-grey f-500">Clients</div>
              <div className="f-black f-18 f-500 my-2">
                {subscriptionData?.Usage?.Clients}
              </div>
            </div>
            <div className="p-3 flex-1 item">
              <div className="f-grey f-500">Prospect Licenses</div>
              <div className="f-black f-18 f-500 my-2">
                {subscriptionData?.Usage?.Prospect_Licenses}
              </div>
            </div>
            <div className="p-3 flex-1  item">
              <div className="f-grey f-500">Standard Licenses</div>
              <div className="f-black f-18 f-500 my-2">
                {subscriptionData?.Usage?.Standard_Licenses}
              </div>
            </div>
            <div className="p-3 flex-1  item">
              <div className="f-grey f-500">Premium Licences</div>
              <div className="f-black f-18 f-500 my-2">
                {subscriptionData?.Usage?.Premium_Licences}
              </div>
            </div>
          </div>
        </>
      )}
          
      <div className="d-none align-items-center justify-content-between mt-3 mb-2">
        <div>Billing</div>
        <div className="d-flex align-items-center">
        <button className="hg-blue-btn py-1 px-2 btn btn-primary">
          Add
        </button>

        {/* <Button className="hg-blue-btn">Add</Button> */}
        </div>
      </div>

      <div className="bg-grey radius-8 border-parent overflow-x-auto hide-scrollbar d-grid d-none">
        {[
          {
            date: "Jan 1, 2024",
            description: "Monthly Subscription - Starter Plan",
            status: "Pending",
            amount: "295.00"
          },
          {
            date: "Jan 1, 2024",
            description: "Premium Licenses (11)",
            status: "Paid",
            amount: "110.00"
          },
          {
            date: "Dec 1, 2023",
            description: "Monthly Subscription - Starter Plan",
            status: "Paid",
            amount: "295.00"
          },
          {
            date: "Dec 1, 2023",
            description: "Premium Licenses (11)",
            status: "Paid",
            amount: "110.00"
          },
          {
            date: "Nov 1, 2023",
            description: "Monthly Subscription - Starter Plan",
            status: "Paid",
            amount: "295.00"
          }
        ].map((invoice) => {
          return (
            <div className="border-item d-flex align-items-center justify-content-between no-wrap gap-24 p-3 billing-table">
              <div className="d-flex align-items-center gap-8">
                <div>{invoice.date}</div>
                <div className="f-grey">{invoice.description}</div>
              </div>
              <div className="d-flex align-items-center gap-8">
                <div>
                  <StatusIndicator status={invoice.status} />
                </div>
                <div className="text-align-end" style={{ minWidth: '80px' }}>£ {invoice.amount}</div>
                <div>
                  <Dropdown alignRight className={`transparennt-wrapper-dropdown my-dropdown`}>
                    <Dropdown.Toggle>
                      <img
                        alt=""
                        src="/images/supply-chain/horizontal-dots.svg"
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      className="menu"
                      popperConfig={{ strategy: "fixed" }}
                    >
                      <div>
                        <h4 className="m-0 f-12 line-height-18 f-darkgrey f-400-imp px-3">Status</h4>
                        <div className="mt-1 d-flex flex-column">
                          {SUBSCRIPTION_STATUSES.map((status) => (
                            <div key={status.value} className="d-flex align-items-center gap-8 bg-hover-grey pointer py-1 px-3">
                              <SuccessSignIcon 
                                className="f-grey" width={12} height={9}
                                style={{
                                  ...(status.value !== invoice.status && {
                                    opacity: 0
                                  })
                                }} 
                              />
                              <StatusIndicator status={status.value} />
                            </div>
                          ))}
                        </div>
                        <div className="px-3">
                          <hr className="mb-1 mt-2" />
                        </div>
                        <div className="px-3 py-1 bg-hover-grey pointer">
                          <div className="f-grey f-14 line-height-22 f-400">Delete</div>
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MspAccountSubscriptions;
